export function normalizeJobStatus(status) {
  return String(status || '').toLowerCase();
}

export function getJobStatusMetadata(metadata, status) {
  const normalizedStatus = normalizeJobStatus(status);
  const statuses = metadata && Array.isArray(metadata.job_statuses)
    ? metadata.job_statuses
    : [];

  return (
    statuses.find(
      (item) => normalizeJobStatus(item && item.value) === normalizedStatus
    ) || null
  );
}

export function getJobStatusLabel(metadata, status) {
  const statusMetadata = getJobStatusMetadata(metadata, status);
  if (statusMetadata && statusMetadata.label) return statusMetadata.label;
  return status == null || status === '' ? 'N/A' : String(status);
}

export function getJobStatusColor(metadata, status) {
  const statusMetadata = getJobStatusMetadata(metadata, status);
  // Ant Design's "default" tag is light-on-light and hard to read; prefer cyan.
  return (statusMetadata && statusMetadata.tag_color) || 'cyan';
}

export function isJobStatusPollable(metadata, status) {
  const statusMetadata = getJobStatusMetadata(metadata, status);
  return !!(statusMetadata && statusMetadata.pollable);
}

export function isJobStatusDeletable(metadata, status) {
  const statusMetadata = getJobStatusMetadata(metadata, status);
  return !!(statusMetadata && statusMetadata.deletable);
}

export function doesJobStatusLoadSuggestion(metadata, status) {
  const statusMetadata = getJobStatusMetadata(metadata, status);
  return !!(statusMetadata && statusMetadata.loads_suggestion);
}

export function isJobStatusFailure(metadata, status) {
  const statusMetadata = getJobStatusMetadata(metadata, status);
  return !!(statusMetadata && statusMetadata.failure);
}

export function getJobStatusOptions(metadata) {
  return metadata && Array.isArray(metadata.job_statuses)
    ? metadata.job_statuses
    : [];
}
